import React from "react";
import {
  Button,
  withStyles,
  Grid,
  TextField,
  InputAdornment,
  Select,
} from "@material-ui/core";
import clsx from "clsx";

const styles = {
  button: {
    minWidth: "calc(100%)",
    background: "white",
  },
};

class Navi_Buttons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: "Wit",
      value: undefined,
    };
  }

  render() {
    const { classes, className, history } = this.props;

    var Change_State = this.props.Change_State;
    var ShowColorCalculator = this.props.ShowColorCalculator;

    let relative_url = window.location.pathname.split("/");
    relative_url.pop();
    relative_url = relative_url.join("/");
    relative_url = ".";

    const go_to_page = (e) => {
      if (e.keyCode === 13) {
        history.push(relative_url + "/" + e.target.value);
        Change_State(e.target.value);
      }
    };

    return (
      <Grid
        style={{
          width: "calc(100%)",
          height: "calc(100%)",
        }}
        container
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={2}>
          <Button
            className={clsx(classes.button, className)}
            onClick={() => {
              history.push(relative_url + "/1");
              Change_State(1);
            }}
            disabled={Number(this.props.value) <= 1}
          >
            {"<--"}
          </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            className={clsx(classes.button, className)}
            onClick={() => {
              const new_value = Number(this.props.value) - 1;
              history.push(relative_url + "/" + new_value);
              Change_State(new_value);
            }}
            disabled={Number(this.props.value) <= 1}
          >
            {"<-"}
          </Button>
        </Grid>
        <Grid item xs={4}>
          <TextField
            placeholder={this.props.max <= 0 ? 0 : this.props.value}
            size={"small"}
            variant="outlined"
            InputProps={{
              startAdornment: ShowColorCalculator && (
                <InputAdornment position="start">
                  <Select
                    IconComponent={() => null}
                    value={this.state.color}
                    onChange={(e, value) => {
                      let new_value;
                      if (e.target.value === "Wit") {
                        if (this.state.color === "Geel") {
                          new_value = this.state.value - 1000;
                        } else if (this.state.color === "Oranje") {
                          new_value = this.state.value - 2000;
                        }
                        this.setState({
                          color: e.target.value,
                          value: new_value,
                        });
                      } else if (e.target.value === "Geel") {
                        if (this.state.color === "Wit") {
                          new_value = this.state.value + 1000;
                        } else if (this.state.color === "Oranje") {
                          new_value = this.state.value - 1000;
                        }
                        this.setState({
                          color: e.target.value,
                          value: new_value,
                        });
                      } else {
                        if (this.state.color === "Wit") {
                          new_value = this.state.value + 2000;
                        } else if (this.state.color === "Geel") {
                          new_value = this.state.value + 1000;
                        }
                        this.setState({
                          color: e.target.value,
                          value: new_value,
                        });
                      }
                    }}
                  >
                    <option value="Wit">Wit</option>
                    <option value="Geel">Geel</option>
                    <option value="Oranje">Oranje</option>
                  </Select>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  / {this.props.max}
                </InputAdornment>
              ),
            }}
            style={{ display: "inline-block" }}
            value={this.state.value}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value < 1001) {
                this.setState({ color: "Wit", value: value });
              } else if (value < 2001) {
                this.setState({ color: "Geel", value: value });
              } else {
                this.setState({ color: "Oranje", value: value });
              }
            }}
            onKeyDown={go_to_page}
          />
        </Grid>
        <Grid item xs={2}>
          <Button
            className={clsx(classes.button, className)}
            onClick={() => {
              const new_value = Number(this.props.value) + 1;
              history.push(relative_url + "/" + new_value);
              Change_State(new_value);
            }}
            disabled={Number(this.props.value) >= Number(this.props.max)}
          >
            {"->"}
          </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            className={clsx(classes.button, className)}
            onClick={() => {
              const new_value = Number(this.props.max);
              history.push(relative_url + "/" + new_value);
              Change_State(new_value);
            }}
            disabled={Number(this.props.value) >= Number(this.props.max)}
          >
            {"-->"}
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(Navi_Buttons);
